import React, { ReactElement } from 'react'
import ErrorTemplate from '../templates/ErrorTemplate'

const Error401Unauthorized = (): ReactElement => {
  return (
    <ErrorTemplate>
      <>
        <div className="mt25">
          <h1 className="errorPageTitle">
            Nous sommes désolés, mais cette page n&apos;est malheureusement pas
            disponible.
          </h1>
          <p className="mt5 mb5 fontWeightBold fontSizeXs lh16">
            Merci de revenir ultérieurement, en cas de besoin vous pouvez
            contacter le 01.44.88.30.05 ou votre banquier privé
          </p>
        </div>
      </>
    </ErrorTemplate>
  )
}

export default Error401Unauthorized
